import React from 'react'
import MetlinkReportComponent from '../Components/MetlinkReport/MetlinkReportComponent' 

function MetlinkReportPage() {
    return (
        <MetlinkReportComponent/>
    )
}

export default MetlinkReportPage